import { useSnackbar } from "notistack";

export const useSnackbarHook = () => {
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  return { handleClick };
};


